namespace gotoAndPlay {

    $(function() {

        $('body').on('click', function(e) {

            if($(e.target).hasClass('product__gallery-link')) {
                if(!$(e.target).hasClass('js-current')) {
                    $('.js-show').removeClass('js-show');
                    $('.js-current').removeClass('js-current');
                    $(e.target).addClass('js-current');
                    $($(e.target).attr('data-target')).addClass('js-show');
                }
            }

            if($(e.target).hasClass('product__gallery-images')) {
                var currentpic = $(e.target).find('.js-show');
                var nextpic = 'image_1';

                if(currentpic.next('.product__image').length){
                    nextpic = currentpic.next('.product__image').attr('id');
                }

                $(e.target).next('.product__gallery-nav').find('div[data-target="#'+nextpic+'"]').trigger('click');
            }

        });

    });
}
